// extracted by mini-css-extract-plugin
export default {"input":"weight-field_input__I9ET5","inpInner":"weight-field_inpInner__wz2Z2"};